<div class="modal-overlay" *ngIf="isOpen" [class.closing]="isClosing" (click)="onClose()">
  <div class="modal-container" [class.closing]="isClosing" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Reward Setting</h2>
      <button class="close-button" type="button" (click)="onClose()" aria-label="Close">
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 3L3 9M3 3L9 9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <div class="modal-content">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-row form-row--name-and-amount">
          <div class="form-group">
            <label class="field-label">Reward Name<span class="required">*</span></label>
            <input
              type="text"
              class="form-input"
              formControlName="name"
              placeholder="e.g. Monthly $50"
              [class.error]="getFieldError('name')"
            />
            <div class="error-message" *ngIf="getFieldError('name')">
              {{ getFieldError('name') }}
            </div>
          </div>

          <div class="form-group">
            <label class="field-label">Reward Amount<span class="required">*</span></label>
            <input
              type="number"
              class="form-input"
              formControlName="amount"
              placeholder="e.g. $2"
              step="0.01"
              [min]="0.01"
              [max]="200"
              [class.error]="getFieldError('amount')"
            />
            <div class="error-message" *ngIf="getFieldError('amount')">
              {{ getFieldError('amount') }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="field-label">Service Type<span class="required">*</span></label>
          <!--
            The ControlValueAccessor lives on mat-radio-group, not on the individual
            mat-radio-button, so formControlName belongs here (NG01203 otherwise).
          -->
          <mat-radio-group class="radio-group" formControlName="service_type">
            <div class="radio-option" *ngFor="let option of serviceTypeOptions">
              <mat-radio-button [value]="option.value"></mat-radio-button>
              <label [for]="'serviceType_' + option.value">{{ option.label }}</label>
            </div>
          </mat-radio-group>
          <div class="error-message" *ngIf="getFieldError('service_type')">
            {{ getFieldError('service_type') }}
          </div>
        </div>

        <div class="form-row form-row--wash-and-items">
          <div class="form-group form-group--wash-type">
            <label class="field-label">Wash Type<span class="required">*</span></label>
            <app-wi-multi-select
              appearance="form"
              [options]="packageOptions"
              [selectedIds]="form.get('selected_package_ids')?.value ?? []"
              placeholder="Select wash type"
              [multipleSelectionText]="'{{count}} selected'"
              [showTags]="false"
              [error]="!!getFieldError('selected_package_ids')"
              (selectedIdsChange)="onPackageSelectionChange($event)"
            >
            </app-wi-multi-select>
            <div class="field-hint" *ngIf="isLoadingPackages">Loading packages...</div>
            <div class="field-hint" *ngIf="!isLoadingPackages && packageOptions.length === 0">
              No active car wash packages available.
            </div>
            <div class="error-message" *ngIf="getFieldError('selected_package_ids')">
              {{ getFieldError('selected_package_ids') }}
            </div>
          </div>

          <div class="form-group form-group--items-sold">
            <label class="field-label">Items sold<span class="required">*</span></label>
            <select
              class="form-select"
              formControlName="items_sold"
              [class.error]="getFieldError('items_sold')"
            >
              <option *ngFor="let count of itemsSoldOptions" [ngValue]="count">{{ count }}</option>
            </select>
            <div class="error-message" *ngIf="getFieldError('items_sold')">
              {{ getFieldError('items_sold') }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <app-theme-color-picker formControlName="theme_color"></app-theme-color-picker>
        </div>

        <div class="conflict-alert" *ngIf="conflictError">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
              stroke="#DC2626"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>{{ conflictError }}</span>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <div class="button-group">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="onCancel()"
          [disabled]="isSubmitting || isClosing"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onSubmit()"
          [disabled]="isSubmitting || isClosing || form.invalid"
        >
          {{ submitButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</div>
